"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharePlaceholdersTypeMap = exports.roundFunctionTypes = exports.placeholdersTypeMap = exports.extendedPlaceholdersTypeMap = exports.NUMBER_OF_DECIMALS_MAX_LENGTH = exports.FUNCTION_MEMBER_TYPES = exports.FORMULA_MEMBER_TYPES = exports.EMPTY_ITEM = exports.DEFAULT_FUNCTION_ARGUMENT = exports.DATA_TYPES = void 0;
var _uuid = require("uuid");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NUMBER_OF_DECIMALS_MAX_LENGTH = exports.NUMBER_OF_DECIMALS_MAX_LENGTH = 3;
var FUNCTION_MEMBER_TYPES = exports.FUNCTION_MEMBER_TYPES = {
  MIN: 'Min',
  MAX: 'Max',
  ROUND: 'Round',
  ROUND_UP: 'RoundUp',
  ROUND_DOWN: 'RoundDown',
  LEFT: 'left',
  RIGHT: 'right'
};
var FORMULA_MEMBER_TYPES = exports.FORMULA_MEMBER_TYPES = {
  textOnly: 'text-only',
  variable: 'variable',
  numeric: 'numeric',
  stepper: 'stepper',
  percentage: 'percentage',
  empty: '',
  operator: 'operator',
  functionMember: 'function',
  parenthesis: 'parenthesis'
};
var DATA_TYPES = exports.DATA_TYPES = {
  MIXED: 'MIXED',
  NUMERIC: 'NUMERIC',
  UNKNOWN: 'UNKNOWN'
};
var EMPTY_ITEM = exports.EMPTY_ITEM = {
  type: FORMULA_MEMBER_TYPES.empty,
  dataType: DATA_TYPES.MIXED,
  value: '',
  displayName: '',
  description: ''
};
var DEFAULT_FUNCTION_ARGUMENT = exports.DEFAULT_FUNCTION_ARGUMENT = _objectSpread(_objectSpread({}, EMPTY_ITEM), {}, {
  type: FORMULA_MEMBER_TYPES.variable,
  dataType: DATA_TYPES.MIXED
});
var roundFunctionTypes = exports.roundFunctionTypes = [FUNCTION_MEMBER_TYPES.ROUND, FUNCTION_MEMBER_TYPES.ROUND_UP, FUNCTION_MEMBER_TYPES.ROUND_DOWN];
var defaultRoundFunctionArguments = [[_objectSpread({
  key: (0, _uuid.v4)()
}, EMPTY_ITEM)], [_objectSpread({
  key: (0, _uuid.v4)()
}, _objectSpread(_objectSpread({}, EMPTY_ITEM), {}, {
  type: FORMULA_MEMBER_TYPES.numeric,
  dataType: DATA_TYPES.NUMERIC
}))]];
var placeholdersTypeMap = exports.placeholdersTypeMap = {
  1: _objectSpread({}, EMPTY_ITEM),
  3: {
    type: FORMULA_MEMBER_TYPES.functionMember,
    value: FUNCTION_MEMBER_TYPES.MIN,
    arguments: [[_objectSpread({
      key: (0, _uuid.v4)()
    }, EMPTY_ITEM)], [_objectSpread({
      key: (0, _uuid.v4)()
    }, EMPTY_ITEM)]],
    displayName: '',
    description: ''
  },
  5: {
    type: FORMULA_MEMBER_TYPES.functionMember,
    value: FUNCTION_MEMBER_TYPES.MAX,
    arguments: [[_objectSpread({
      key: (0, _uuid.v4)()
    }, EMPTY_ITEM)], [_objectSpread({
      key: (0, _uuid.v4)()
    }, EMPTY_ITEM)]],
    displayName: '',
    description: ''
  },
  7: {
    type: FORMULA_MEMBER_TYPES.textOnly,
    value: '',
    displayName: '',
    description: ''
  },
  9: {
    type: FORMULA_MEMBER_TYPES.stepper,
    value: '',
    displayName: '',
    description: ''
  }
};
var extendedPlaceholdersTypeMap = exports.extendedPlaceholdersTypeMap = {
  1: placeholdersTypeMap[1],
  3: placeholdersTypeMap[3],
  5: placeholdersTypeMap[5],
  7: {
    type: FORMULA_MEMBER_TYPES.functionMember,
    value: FUNCTION_MEMBER_TYPES.ROUND,
    arguments: defaultRoundFunctionArguments,
    displayName: '',
    description: ''
  },
  9: {
    type: FORMULA_MEMBER_TYPES.functionMember,
    value: FUNCTION_MEMBER_TYPES.ROUND_UP,
    arguments: defaultRoundFunctionArguments,
    displayName: '',
    description: ''
  },
  11: {
    type: FORMULA_MEMBER_TYPES.functionMember,
    value: FUNCTION_MEMBER_TYPES.ROUND_DOWN,
    arguments: defaultRoundFunctionArguments,
    displayName: '',
    description: ''
  },
  13: placeholdersTypeMap[7],
  15: placeholdersTypeMap[9]
};
var sharePlaceholdersTypeMap = exports.sharePlaceholdersTypeMap = {
  1: placeholdersTypeMap[1],
  3: placeholdersTypeMap[7],
  5: placeholdersTypeMap[9]
};